import styled from "styled-components";

export const ModalHeader = styled.div`
  background: linear-gradient(136.67deg, #8d2e36 8.34%, #ca3832 95.26%);
  padding: 1em 2em 1.5em;
  opacity: 1;
`;
